import { http } from '@/public/utils/http'
import { random } from '@/public/utils'
import { API_CODE_MAP } from './constant'
import { REGION_ORDER_IDS } from './store'
import bus from '@/public/utils/bus'

let basePanelData
export async function createBaseAreaDataById (districtIds = REGION_ORDER_IDS) {
  try {
    // 该接口产生的数据都是从中国开始到子节点的全链路
    if (basePanelData) {
      return basePanelData
    }
    const result = await http(API_CODE_MAP.FP_CODE.url, { districtIds, time: random() }, { appkey: API_CODE_MAP.FP_CODE.appkey })
    if (result) {
      basePanelData = result
    }
    return result
  } catch (error) {
    console.info(error)
  }
}
// 全局注册组件时就加载数据。下一次直接获取内存中的。防止多个地址组件同时挂载报错。
bus && bus.$once && bus.$once('APP_LOADED', createBaseAreaDataById)

export async function getInfoByDistrictIds (districtIds = REGION_ORDER_IDS) {
  try {
    // 该接口产生的数据都是从中国开始到子节点的全链路
    const result = await http(API_CODE_MAP.FP_CODE.url, { districtIds, time: random() }, { appkey: API_CODE_MAP.FP_CODE.appkey })
    return result
  } catch (error) {
    console.info(error)
  }
}

export async function getAreaNodeChildrenById (districtID) {
  try {
    if (!districtID) {
      return null
    }
    // 该接口产生的数据都是从中国开始到子节点的全链路
    const result = await http(API_CODE_MAP.CHILDREN_CODE.url, {
      params: {
        districtID,
        showParam: 1
      }
    }, { appkey: API_CODE_MAP.CHILDREN_CODE.appkey })
    if (result && result.districtList && Array.isArray(result.districtList)) {
      return [...result.districtList]
    }
    return null
  } catch (error) {
    console.info(error)
  }
}

export const REG_NUMBER = /^\d+$/
// 生成级别限制的入参。 总是大于1的参数
function createSearchLevels (level) {
  if (level) {
    return +level === 1 ? '2' : Array.from(Array(level - 1), (_, i) => i + 2).join(',')
  }
  return false
}

export async function inputSearch (value, searchOption, level) {
  try {
    let zoneCode
    const {
      range = 1,
      // inputLength = 1,
      level: _level,
      limitSize,
      levels: _levels
    } = searchOption || {}
    let keyWord = String(value).trim()
    const isNumber = REG_NUMBER.test(keyWord)
    // if (!keyWord || keyWord.length < (isNumber ? 2 : inputLength)) {
    //   return
    // }
    if (isNumber) {
      zoneCode = keyWord
      keyWord = ''
    }
    let levels

    const l = _level || level
    if (l) {
      levels = createSearchLevels(l)
    }
    // 该接口产生的数据都是从中国开始到子节点的全链路
    const result = await http(API_CODE_MAP.SEARCH_CODE.url, {
      method: 'address.regioninfo.getAreaAddress',
      jsonrpc: '2.0',
      params: {
        keyWord,
        zoneCode,
        range,
        levels: _levels || levels,
        limitSize
      },
      time: random()
    }, { appkey: API_CODE_MAP.SEARCH_CODE.appkey, cancel: true })
    return result
  } catch (error) {
    // 报错了就直接返回空数据
    return false
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-area/data/api.js